import { useState } from 'react';

export function PublishedIframe({ src, mobilePreview }: { src: string; mobilePreview: boolean }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {!loaded && (
        <div className="LoadingWrapper">
          <div className="LoadingWrapper--Loader"></div>
        </div>
      )}
      <iframe
        src={src}
        id="viewer-iframe"
        className={mobilePreview ? 'viewer-iframe--mobile' : ''}
        onLoad={() => {
          setLoaded(true);
        }}
      />
    </>
  );
}
